var image_viewer_rtlignore_default = {
  "fontElementMap": "_9uk3v",
  "imageContainer": "JFACH",
  "expandContainer": "z--B-",
  "expandIcon": "DJvjy",
  "pointer": "JU00H",
  "imageWrapper": "xiu1o",
  "imageRatio": "_8dkdj",
  "image": "Y19NG",
  "imageOverlay": "fCjxA",
  "imageCaption": "MxR79",
  "imagePreload": "-k7b0",
  "imageHighres": "TQ2-1",
  "onlyHighRes": "XfpG4",
  "image_loading": "XD43G"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
